import { connect } from 'react-redux';

import AddFormButton from './component';

const mapStateToProps = null;

const mapDispatchToProps = null;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddFormButton);
